module.exports = __webpack_public_path__ + "static/media/screen7.e3ae50c1.png";